<template>
    <div class="functionService" id="functionService">
        <div class="title">
            <div class="title-content">功能服务</div>
        </div>

        <div class="functionService-stick">
            <div class="stick-color"></div>
        </div>

        <div class="cards">
            <div class="card-body" id="card-body">
            <div class="card-style">
                <div class="img">
                    <img :src="msg1" class="icon">
                </div>
                <div class="card-title">
                    设备数据上云
                </div>
                <div class="card-article">
                    通过物联网技术，采集分析设备的运行数据与异常信息
                </div>
            </div>
            <div class="card-style">
                <div class="img">
                    <img :src="msg2" class="icon">
                </div>
                <div class="card-title">
                    小智管家APP
                </div>
                <div class="card-article">
                    为设备使用方提供设备状态监控、资料查询、售后咨询的服务
                </div>
            </div>
            <div class="card-style">
                <div class="img">
                    <img :src="msg3" class="icon">
                </div>
                <div class="card-title">
                    运营态势感知
                </div>
                <div class="card-article">
                    通过可视化图表来展示： 设备运行、备件供应、维修工单、智能客服大数据
                </div>
            </div>
            <div class="card-style">
                <div class="img">
                    <img :src="msg4" class="icon">
                </div>
                <div class="card-title">
                    智能客服系统
                </div>
                <div class="card-article">
                    人工+机器人结合的方式， 为客户提供最高效的售后响应
                </div>
            </div>
            <div class="card-style">
                <div class="img">
                    <img :src="msg5" class="icon">
                </div>
                <div class="card-title">
                    售后服务引擎
                </div>
                <div class="card-article">
                    灵活对接制造商信息化系统，提供标准化的维修工单、备件销售、备件管理的服务功能
                </div>
            </div>
            <div class="card-style">
                <div class="img">
                    <img :src="msg6" class="icon">
                </div>
                <div class="card-title">
                    供需资源优化
                </div>
                <div class="card-article">
                    提供备件防伪溯源功能，通过人工智能算法对备件库存与供应链进行优化
                </div>
            </div>
            </div>
        </div>



    </div>
</template>

<script>
    import msg1 from '@/assets/index/img/service/供需资源优化.png'
    import msg2 from '@/assets/index/img/service/售后服务引擎.png'
    import msg3 from '@/assets/index/img/service/小智管家APP.png'
    import msg4 from '@/assets/index/img/service/智能客服系统.png'
    import msg5 from '@/assets/index/img/service/设备数据上云.png'
    import msg6 from '@/assets/index/img/service/运营态势感知.png'
    export default {
        name: "functionService",
        data(){
            return{
                msg1:msg1,
                msg2:msg2,
                msg3:msg3,
                msg4:msg4,
                msg5:msg5,
                msg6:msg6,
                width:document.body.clientWidth
            }
        },
        created(){
            this.width=document.body.clientWidth
        },
        mounted(){
            window.addEventListener('resize', this.handelWidth, false)
            this.handelWidth()
        },
        beforeDestroy(){
            window.removeEventListener("resize",this.handelWidth, false)
        },
        methods:{
            handelWidth(){
                this.width=document.body.clientWidth
                let w=document.body.clientWidth
                let cardBody=document.getElementById("card-body")
                let functionService=document.getElementById("functionService")
                // let cardStyle=document.getElementsByClassName("card-style")
                // let icon=document.getElementsByClassName("icon")
                // let cardTitle=document.getElementsByClassName("card-title")
                // // let cardArticle=document.getElementsByClassName("card-article")
                if(w>=1900){
                    cardBody.style.paddingLeft="10%"
                    functionService.style.height="700px"
                    // cardStyle.forEach(item=>{
                    //     item.style.width="30%"
                    // })
                    // icon.forEach(item=>{
                    //     item.style.width="100px"
                    // })
                }else if (1800<=w&&w<1900){
                    cardBody.style.paddingLeft="8%"
                    functionService.style.height="700px"
                    // cardStyle.forEach(item=>{
                    //     item.style.width="30%"
                    // })
                    // icon.forEach(item=>{
                    //     item.style.width="100px"
                    // })
                    // cardTitle.forEach(item=>{
                    //     item.style.left="50%"
                    //     item.style.fontSize="24px"
                    // })
                }else if (1700<=w&&w<1800){
                    cardBody.style.paddingLeft="6%"
                    functionService.style.height="700px"
                }else if (1600<=w&&w<1700){
                    cardBody.style.paddingLeft="4%"
                    functionService.style.height="700px"
                }else if (1500<=w&&w<1600){
                    cardBody.style.paddingLeft="17%"
                    functionService.style.height="1000px"
                }else if (1400<=w&&w<1500){
                    cardBody.style.paddingLeft="16%"
                    functionService.style.height="1000px"
                }else if (1300<=w&&w<1400){
                    cardBody.style.paddingLeft="13%"
                    functionService.style.height="1000px"
                }else if (1200<=w&&w<1300){
                    cardBody.style.paddingLeft="10%"
                    functionService.style.height="1000px"
                }else if (1100<=w&&w<1200){
                    cardBody.style.paddingLeft="6%"
                    functionService.style.height="1000px"
                }
            }
        }
    }
</script>

<style scoped>
    .functionService{
        /*width:100%;*/
        height:700px;
        background:#F0F2F5;
        /*background: no-repeat center;*/
        /*background-size: cover;*/
        /*-webkit-background-size: cover;*/
        /*-moz-background-size: cover;*/
        /*-o-background-size: cover;*/
        /*min-height: 50em;*/
        overflow: auto;
        position: relative;
    }
    .title{
        width: 100%;
        position: absolute;
        top: 65px;
    }
    .title-content{
        margin: 0 auto;
        width:180px;
        height:50px;
        font-size:36px;
        font-family:Alibaba PuHuiTi;
        font-weight:500;
        line-height:50px;
        color:rgba(39,93,220,1);
        letter-spacing:9px;
        opacity:1;
    }
    .functionService-stick{
        width: 100%;
        position: absolute;
        top: 125px;
    }
    .stick-color{
        margin: 0 auto;
        width:40px;
        height:6px;
        background:rgba(39,93,220,1);
        opacity:1;
    }
    .cards{
        width: 100%;
        position: absolute;
        top: 170px;
    }
    .card-body{
        padding-left: 5%;
    }
    .card-style{
        width:460px;
        /*min-width: 260px;*/
        height:200px;
        background:rgba(250,252,255,1);
        box-shadow:0px 3px 12px rgba(27,61,142,0.1);
        position: relative;
        margin-left: 20px;
        margin-right: 20px;
        margin-top: 30px;
        float: left;
    }
    .img{
        position: absolute;
        top: 10%;
        left: 10%;
    }
    .icon{
        width: 100px;
    }


    .card-title{
        width:150px;
        height:33px;
        font-size:24px;
        font-family:Alibaba PuHuiTi;
        font-weight:500;
        line-height:33px;
        color:rgba(15,19,38,1);
        opacity:1;
        position: absolute;
        left: 50%;
        top: 10%;
    }
    .card-article{
        position: absolute;
        left: 44%;
        top: 99px;
        width:49%;
        height:61px;
        font-size:14px;
        font-family:Alibaba PuHuiTi;
        font-weight:400;
        line-height:20px;
        color:rgba(15,19,38,1);
        opacity:1;
        text-align: left;
    }




</style>
